export default __webpack_public_path__ + "static/media/Increase-Icon.a3056ca0.svg";